import { useState, useMemo } from 'react';
import { faqs } from '@/mocks/site-content';
import SEOHead from '@/components/base/SEOHead';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  }), []);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <SEOHead schema={faqSchema} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="font-heading text-accent-500 text-sm tracking-[0.2em] uppercase mb-3 whitespace-nowrap">
            Frequently Asked
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            常见<span className="text-primary-600">问题</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left transition-colors duration-200"
              >
                <h3 className="font-heading text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-foreground-600"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}